import axios from "axios";

import { LMS_BASE_URL } from "../../../../utils/http/http-common";

import { LMS_TOKEN } from "../../../../utils/cookiesmanager";
import { getLMSData } from "../../../../utils/getLMSData";

export const getCoursesApiCall = async (languageid = 1) => {
  const token = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/course?languageId=${languageid}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {

    const {response} = error || {};

  if(response?.data?.statusCode  === 401){
      getLMSData();
    }

    throw error.config.data;
  }
};
